<div class="fa-select">
  @if (label) {
    <label
      >{{ label }}
      @if (required) {
        <span class="text-red-500">*</span>
      }
      <!-- The filter is invisible otherwise: a leaf account that will not accept a click looks broken
           rather than reserved. -->
      @if (!readonly) {
        <i class="pi pi-info-circle fa-select__info" [pTooltip]="filterHint()" tooltipPosition="top"></i>
      }
    </label>
  }

  <p-treeSelect
    [(ngModel)]="selectedValue"
    [ngModelOptions]="{ standalone: true }"
    [options]="treeNodes()"
    selectionMode="single"
    [filter]="true"
    filterBy="label"
    [showClear]="true"
    [placeholder]="placeholder"
    [disabled]="readonly"
    appendTo="body"
    styleClass="w-full"
    [ngClass]="{ 'ng-invalid ng-dirty': required && !referenceControl.value && referenceControl.touched }"
    (onNodeSelect)="onNodeSelect($event)"
    (onNodeUnselect)="onClear()"
    (onClear)="onClear()"
  >
    <ng-template pTemplate="value" let-value>
      <!-- Name-first: show the account name as the main value when available, else the number. -->
      @if (nameValue()) {
        <span>{{ nameValue() }}</span>
      } @else if (numberValue()) {
        <span>{{ numberValue() }}</span>
      } @else {
        <span class="text-surface-400">{{ placeholder }}</span>
      }
    </ng-template>

    <ng-template pTemplate="footer">
      <div class="fa-select__legend">
        <i class="pi pi-info-circle"></i>
        <span>{{ filterHint() }}</span>
      </div>
    </ng-template>
  </p-treeSelect>

  <!-- The account number as small secondary text, once a name is shown above. -->
  @if (nameValue() && numberValue()) {
    <small class="text-gray-500">{{ numberValue() }}</small>
  }
</div>
